import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
} from '@mui/material';
import { fmtMoney, payeeLabel } from '../../utils/format';

// ยืนยันการอนุมัติ/ปฏิเสธ/รอก่อน (หรือ ตรวจสอบแล้ว/พบปัญหา/รอก่อน ตาม mode) + หมายเหตุ — รองรับทั้ง
// single-row และ bulk (actionDialog.rows)
export default function ActionConfirmDialog({
  mode,
  actionDialog,
  note,
  setNote,
  busy,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog
      open={!!actionDialog}
      onClose={() => !busy && onCancel()}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        ยืนยัน{mode.actionLabel[actionDialog?.action] || ''}{mode.dialogSubject}
        {actionDialog?.rows?.length > 1 && ` (${actionDialog.rows.length} รายการ)`}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {actionDialog?.rows?.length === 1 ? (
            <>
              {payeeLabel(actionDialog.rows[0])} —{' '}
              {fmtMoney(actionDialog.rows[0]?.net_price || actionDialog.rows[0]?.price)}{' '}
              บาท
            </>
          ) : (
            <>
              {actionDialog?.rows?.length || 0} รายการ — รวม{' '}
              {fmtMoney(
                (actionDialog?.rows || []).reduce(
                  (sum, r) => sum + (Number(r.net_price) || Number(r.price) || 0),
                  0,
                ),
              )}{' '}
              บาท
            </>
          )}
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={2}
          label="หมายเหตุ (ถ้ามี)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          ยกเลิก
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={busy}>
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
}
